// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9bc0101c","845":"c11d4451"}[chunkId] + ".chunk.js";
};